export const APP_NAME = 'syk-inn'
